import { render } from "./App.vue?vue&type=template&id=9f2aac34"
const script = {}

import "./App.vue?vue&type=style&index=0&id=9f2aac34&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__